import { API_BASE_URL, authFetch, getHeaders as baseGetHeaders } from './authFetch';

const USERS_PREFIX = `${API_BASE_URL}/api/v1/users`;

function getHeaders(withJson = true): Record<string, string> {
  return baseGetHeaders(withJson);
}

interface WidgetCanvasResponse {
  payload: Record<string, unknown>;
  updated_at: number;
}

const WIDGET_CANVAS_FETCH_CACHE_MS = 2000;

let widgetCanvasFetchPromise: Promise<WidgetCanvasResponse> | null = null;
let widgetCanvasFetchCache: {
  value: WidgetCanvasResponse;
  fetchedAt: number;
} | null = null;

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}

export async function fetchWidgetCanvasFromCloud(): Promise<WidgetCanvasResponse> {
  const now = Date.now();
  if (
    widgetCanvasFetchCache
    && now - widgetCanvasFetchCache.fetchedAt < WIDGET_CANVAS_FETCH_CACHE_MS
  ) {
    return widgetCanvasFetchCache.value;
  }
  if (widgetCanvasFetchPromise) {
    return widgetCanvasFetchPromise;
  }

  widgetCanvasFetchPromise = authFetch(`${USERS_PREFIX}/me/widget-canvas`, {
    headers: getHeaders(),
  })
    .then((res) => handleResponse<WidgetCanvasResponse>(res))
    .then((value) => {
      widgetCanvasFetchCache = {
        value,
        fetchedAt: Date.now(),
      };
      return value;
    })
    .finally(() => {
      widgetCanvasFetchPromise = null;
    });

  return widgetCanvasFetchPromise;
}

export async function saveWidgetCanvasToCloud(
  payload: unknown,
  updatedAt: number,
): Promise<WidgetCanvasResponse> {
  const res = await authFetch(`${USERS_PREFIX}/me/widget-canvas`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({
      payload,
      updated_at: updatedAt,
    }),
  });
  const value = await handleResponse<WidgetCanvasResponse>(res);
  widgetCanvasFetchCache = {
    value,
    fetchedAt: Date.now(),
  };
  return value;
}
